export const TEMPLATE_XFLOW_MESSAGE_TEMPLATE_ID = 'twc-sidenav-banner';

export const TEMPLATE_XFLOW_PLACEMENT_ID = 'confluence-side-nav';

export const TEMPLATE_XFLOW_RENDER_EXPERIENCE = 'twcg-2112-confluence-template-xflow-banner-render';

export const TEMPLATE_XFLOW_RENDER_FAILURE_REASON = 'renderer-error';

export const TEMPLATE_XFLOW_RENDER_ABORT_REASONS = {
	DELIVERY_CANCELLED: 'delivery-cancelled',
	POST_OFFICE_TEARDOWN: 'post-office-teardown',
	COMPONENT_UNMOUNTED: 'component-unmounted',
} as const;
